import React from 'react';
import i18n from '../i18n';
import { Trans, withTranslation } from 'react-i18next';
import { updateRoomStatus } from './../models/room';
import Clock from './clock';
import Button from './button';
import RoomNumber from './snippets/room-number';
import RoomStatus from './snippets/room-status';
import NotificationSoundFile from './../assets/sounds/notification.mp3';


class ErevYomKippurMode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpdatingStatus: false
    }
    this.notificationSound = new Audio(NotificationSoundFile);
  }

  componentDidUpdate(prevProps) {
    if(this.props.room.status!==prevProps.room.status){
      if(this.props.room.status=="InMikvah"){
        this.notificationSound.play();
      }
    }
  }

  handleChangeStatus() {
      let status = "ReadyForMikvah"; 
      this.setState({
        isUpdatingStatus: true,
      })
      updateRoomStatus(this.props.room.id, status)
        .then(
          result => {
            this.setState({
              isUpdatingStatus: false,
            });
          },
          error => {
            this.setState({
              isUpdatingStatus: false,
              error
            });
          });
    }
  
  screen(room) {
    const he = i18n.getFixedT('he');
    const en = i18n.getFixedT('en');
    switch (room.status) {
      case 'Ready':
        return (<><h1 className="side">{he("eykAvailable")}</h1><h1 className="dir-ltr side">{en("eykAvailable")}</h1></>);
      case 'Prep':
        return <>
        <div className="side">
          <p className="notice">{he("eykPrepNotice")}</p>
          <p>{he("eykPrep")}</p>
          <Button type="circle-big" onClick={() => this.handleChangeStatus()} loading={this.state.isUpdatingStatus}>{he("I’m Ready")}</Button>
        </div>
        <div className="side dir-ltr">
          <p className="notice">{en("eykPrepNotice")}</p>
          <p>{en("eykPrep")}</p>
          <Button type="circle-big" onClick={() => this.handleChangeStatus()} loading={this.state.isUpdatingStatus}>{en("I’m Ready")}</Button>
        </div></>;
      case 'ReadyForMikvah':
      case 'ReadyForMikvahNext':
        return <>
        <div className="side ready">
          <p>{he("eykReady")}</p>
          <>
            <p className="title">{he("There are")}</p>
            <p className="number">{room.readyForMikvahPosition}</p>
            <p className="title mb-0">{he("Ahead of you for tevilah")}</p>
          </>
        </div>
        <div className="side dir-ltr ready">
          <p>{en("eykReady")}</p>
          <>
            <p className="title">{en("There are")}</p>
            <p className="number">{room.readyForMikvahPosition}</p>
            <p className="title mb-0">{en("Ahead of you")}</p>
          </>
        </div>
        </>; 
      case 'InMikvah':
        return <>
        <h2 className="side"><Trans i18nKey="eykInMikvah" t={he}><div></div>{{roomNumber:room.id}}</Trans></h2>
        <h2 className="side dir-ltr"><Trans i18nKey="eykInMikvah" t={en}><div></div>{{roomNumber:room.id}}</Trans></h2>
        </>;  
      case 'Dressing':
        return <>
        <h2 className="side"><Trans i18nKey="eykDressing" t={he}><p></p></Trans></h2>
        <h2 className="side dir-ltr"><Trans i18nKey="eykDressing" t={en}><p></p></Trans></h2></>;
      default:
        return null
    }  
  }

  render() {
    const { t, room, type } = this.props;
    return <div>
      <div className={'container-page view-room eyk-mode status-' + room.effectiveStatus.toLowerCase() + ' lang-' + i18n.language}>
        <header className="header">
          <div>
            <div className="header-left">
              <RoomNumber number={room.id} />
            </div>
            <div className="header-center">
              <Clock />
            </div>
            <div className="header-right">
              <RoomStatus status={room.statusName} color="green" />
            </div>
          </div>
          <div>
            <div className="header-left">
            </div>
            <div className="header-center">
            </div>
            <div className="header-right">
            </div>
          </div>
        </header>
        <div className="container-body">
          {this.screen(room)}
        </div>
      </div>                
    </div>
  }
}

export default withTranslation()(ErevYomKippurMode);